import { z } from "zod";
export const CONTACT_FIELDS = ["fullName", "roomNumber", "email", "phone"];
export const contactSettingsSchema = z.object({
    enabled: z.boolean().default(true),
    profile: z.enum(["automatic", "hotel", "restaurant", "conference", "business", "airport", "custom"]).default("automatic"),
    recipient: z.enum(["manager", "organizer", "team"]).optional(),
    fields: z.array(z.object({ key: z.enum(CONTACT_FIELDS), required: z.boolean().default(false) })).max(4).optional()
}).superRefine((settings, ctx) => {
    if (settings.fields && new Set(settings.fields.map(field => field.key)).size !== settings.fields.length) {
        ctx.addIssue({ code: "custom", message: "Contact fields must be unique", path: ["fields"] });
    }
    if (settings.enabled && settings.profile === "custom" && !settings.fields?.some(field => field.key !== "fullName")) {
        ctx.addIssue({ code: "custom", message: "Select room, email or phone for a manager response", path: ["fields"] });
    }
});
export function contactPreset(profile) {
    return profile === "hotel"
        ? [{ key: "fullName", required: true }, { key: "roomNumber", required: true }]
        : [{ key: "fullName", required: true }, { key: "email", required: false }, { key: "phone", required: false }];
}
export function resolveContactSettings(settings, locationTypeCode) {
    const record = settings && typeof settings === "object" ? settings : {};
    const parsed = contactSettingsSchema.safeParse(record.contact ?? {});
    const contact = parsed.success ? parsed.data : { enabled: true, profile: "automatic" };
    const profile = contact.profile === "automatic"
        ? (isRoomLocation(locationTypeCode) ? "hotel" : ["conference", "session", "conference_hall", "registration", "event_catering"].includes(locationTypeCode ?? "") ? "conference" : ["airport", "terminal", "gate", "baggage"].includes(locationTypeCode ?? "") ? "airport" : ["business", "branch", "service_center", "office"].includes(locationTypeCode ?? "") ? "business" : "restaurant") : contact.profile;
    const recipient = profile === "custom" ? contact.recipient ?? "team" : profile === "conference" ? "organizer" : profile === "hotel" || profile === "restaurant" ? "manager" : "team";
    return { enabled: contact.enabled, profile, recipient, fields: profile === "custom" ? contact.fields ?? [] : contactPreset(profile) };
}
export function isRoomLocation(code) { return ["s", "room", "soba"].includes(code ?? ""); }
export function validateGuestContact(input, settings, context = {}) {
    const policy = resolveContactSettings(settings, context.locationTypeCode);
    const values = {};
    const errors = [];
    if (!input.contactPermission)
        return { values, errors };
    if (!policy.enabled)
        return { values, errors: ["Contact requests are disabled for this survey"] };
    const submitted = { fullName: input.contactName, roomNumber: input.roomNumber, email: input.contactEmail, phone: input.contactPhone };
    for (const field of policy.fields) {
        let value = submitted[field.key]?.trim();
        if (field.key === "roomNumber" && isRoomLocation(context.locationTypeCode) && context.unitCode && (!value || context.allowRoomCorrection === false))
            value = context.unitCode;
        if (field.required && !value)
            errors.push(`Required contact field: ${field.key}`);
        if (value)
            values[field.key] = value;
    }
    if (!values.roomNumber && !values.email && !values.phone)
        errors.push("Contact reference is required");
    return { values, errors };
}
